module.exports = __webpack_public_path__ + "static/media/photo8.01706273.png";